import { MtxIcon } from '@meilleurtaux/mtp-uikit-react';
import { useTranslation } from 'react-i18next';

import styles from './styles.module.css';

const displayedScore = (value: number): number =>
  Number(new Intl.NumberFormat('fr-FR', { maximumFractionDigits: 1, useGrouping: false }).format(value));

const isRiskAligned = (currentScore: number, newScore: number): boolean =>
  displayedScore(currentScore) >= displayedScore(newScore);

interface AllocationProps {
  currentScore: number;
  currentProfile: string;
  newScore: number;
  newProfile: string;
}
export const Allocation: React.FC<AllocationProps> = ({ currentScore, newScore, currentProfile, newProfile }) => {
  const { t } = useTranslation();
  const riskAligned = isRiskAligned(currentScore, newScore);

  return (
    <div className={styles.allocation}>
      <div className={styles.profil}>
        <span className={styles.profilLabel}>{t('allocation.yourProfile')}</span>
        <span className={styles.profilInfo}>
          {currentProfile} {t('format.numberFlexibleTenth', { value: currentScore })} / 7
        </span>
      </div>
      <hr className={styles.separator} />
      <div className={styles.allocationDetails}>
        <p className={styles.profilLabel}>{t('allocation.yourAllocation')}</p>
        <div className={styles.allocationInfoBefore}>
          <div className={styles.before}>
            <span>{t('allocation.before')}</span>
          </div>
          <h3 className={styles.customerInfo}>{currentProfile}</h3>
          <h3 className={styles.customerInfo}>{t('format.numberFlexibleTenth', { value: currentScore })} / 7</h3>
        </div>
        <MtxIcon name="arrow-right" size={24} />
        <div className={styles.allocationInfoBefore}>
          <div className={styles.before}>
            <span>{t('allocation.after')}</span>
          </div>
          <h3 className={styles.customerInfo}>{newProfile}</h3>
          <h3 className={styles.customerInfo}>{t('format.numberFlexibleTenth', { value: newScore })} / 7</h3>
        </div>
      </div>
      <div className={`${styles.alertProfil} ${riskAligned ? styles.alertProfilSuccess : styles.alertProfilWarning}`}>
        <div className={riskAligned ? styles.alertProfilIconSuccess : styles.alertProfilIconWarning}>
          <MtxIcon name={riskAligned ? 'check-circle-solid' : 'warning-solide'} size={24} />
        </div>
        <div className={styles.alertProfilText}>
          <p>{riskAligned ? t('allocation.alignedAllocation') : t('allocation.notAlignedAllocation')}</p>
        </div>
      </div>
    </div>
  );
};
